import React from 'react';

const Logo = ({ className = '', size = 'default' }) => {
  const sizes = {
    small: { width: 140, height: 38 },
    default: { width: 180, height: 48 },
    large: { width: 220, height: 58 }
  };
  
  const { width, height } = sizes[size] || sizes.default;
  
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 200 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="HomeGlow Nails"
    >
      {/* Nail polish bottle icon */}
      <g transform="translate(0, 6)">
        {/* Bottle cap */}
        <rect x="12" y="0" width="16" height="8" rx="2" fill="#c9a962" />
        {/* Bottle neck */}
        <rect x="14" y="8" width="12" height="6" fill="#d4b5a0" />
        {/* Bottle body */}
        <path
          d="M10 14 L10 36 Q10 40 14 40 L26 40 Q30 40 30 36 L30 14 Z"
          fill="#e8c4c4"
        />
        {/* Shine highlight */}
        <path
          d="M14 18 L14 32 Q14 34 16 34 L18 34 Q20 34 20 32 L20 18 Q20 16 18 16 L16 16 Q14 16 14 18 Z"
          fill="#fff"
          opacity="0.4"
        />
        {/* Sparkle dots */}
        <circle cx="35" cy="8" r="2" fill="#c9a962" />
        <circle cx="40" cy="14" r="1.5" fill="#c9a962" opacity="0.7" />
        <circle cx="38" cy="20" r="1" fill="#c9a962" opacity="0.5" />
      </g>
      
      {/* Text */}
      <text
        x="50"
        y="28"
        fontFamily="'Cormorant Garamond', Georgia, serif"
        fontSize="20"
        fontWeight="500"
        fill="#2D2D2D"
        letterSpacing="-0.5px"
      >
        HomeGlow
      </text>
      <text
        x="50"
        y="44"
        fontFamily="'Inter', -apple-system, sans-serif"
        fontSize="11"
        fontWeight="400"
        fill="#6B6B6B"
        letterSpacing="3px"
      >
        NAILS
      </text>
    </svg>
  );
};

export default Logo;
